<div class="dialog-title">
    <h3>{{'forms.Change Phone' | translate}}</h3>

    <span mat-button mat-dialog-close>
        <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998" viewBox="0 0 13.998 13.998">
            <path id="close-btn"
                d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
                transform="translate(5.82 13.32)" fill="#bbb" />
        </svg>
    </span>
</div>
<div mat-dialog-content>

    <mat-stepper linear="true" (window:resize)="onWindowResize($event)"  [orientation]="getScreenWidth < 870?'vertical':'horizontal'" #stepper>
        <mat-step [stepControl]="firstFormGroup" [editable]="false">
            <form [formGroup]="firstFormGroup" class="w-100 m-auto mt-3">
                <ng-template matStepLabel>{{'forms.Enter New Phone' | translate}}</ng-template>
                <div class="inputs-form-section teleInput">
                    <label for="phone" class="text-start pb-2 w-100">{{'auth.phone' | translate}}</label>
                    <ngx-intl-tel-input [cssClass]="'tel-input'" ariaLabel="phone"
                        customPlaceholder="{{'auth.phone' | translate}}" [enableAutoCountrySelect]="true"
                        [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [maxLength]="20"
                        [numberFormat]="PhoneNumberFormat.International" [phoneValidation]="true" [searchCountryField]="[
                              SearchCountryField.Iso2,
                              SearchCountryField.Name
                            ]" [searchCountryFlag]="true" [searchCountryFlag]="true" [selectFirstCountry]="false"
                        [selectedCountryISO]="CountryISO" [separateDialCode]="separateDialCode" formControlName="phone"
                        name="phone">
                    </ngx-intl-tel-input>
                    <mat-error class="mat-intl-error" *ngIf="firstFormGroup.controls['phone'].invalid &&
                     !hasError(firstFormGroup,'phone', 'required') ">
                        {{'validations.Invalid Phone Format' | translate}}
                    </mat-error>
                    <mat-error
                        *ngIf="hasError(firstFormGroup,'phone', 'required') && (firstFormGroup.controls['phone'].touched ||formSubmitAttempt )">
                        {{'validations.required' | translate}}
                    </mat-error>

                </div>
                <div class="mt-2">
                    <button mat-button class="btn btn-primary w-100" [appLoading]="loading"
                        (click)="SubmitPhone(stepper)">{{'items-requests.Next' | translate}}</button>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="secondFormGroup" [editable]="false">
            <ng-template matStepLabel>{{'forms.Submit OTP' | translate}}</ng-template>
            <form [formGroup]="secondFormGroup" class="w-100 m-auto mt-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'auth.phone' | translate}}</mat-label>
                    <input matInput [value]="this.phoneModal?.e164Number" disabled>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'auth.otp' | translate}}</mat-label>
                    <input matInput formControlName="otp" placeholder="Ex: 5486" required maxlength="4" minlength="4"
                        appOnlynumber>
                    <mat-error *ngIf="hasError(secondFormGroup,'otp', 'required')">
                        {{'validations.required' | translate}}
                    </mat-error>
                    <mat-error *ngIf="hasError(secondFormGroup,'otp', 'minlength')">
                        {{'validations.minlength' | translate}} 4
                    </mat-error>

                </mat-form-field>
                <div class="mt-2">
                    <!-- <button mat-button (click)="goBack(stepper)">Back</button> -->
                    <button mat-button class="btn btn-primary w-100" [appLoading]="loading"
                        (click)="SubmitOTP(stepper)">{{'users.Submit' | translate}}</button>
                </div>
            </form>
        </mat-step>
    </mat-stepper>
</div>